import React from 'react';
import { render } from 'react-dom';
import { DefaultRequest } from 'scripts/api';
import { actionCreators } from 'react/api/actions/chat';

Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.Window = class {

  eventLogDiv = null;
  eventLog = null;
  currentIdLocked = null;
  setEventLog = eventLog => (this.eventLog = eventLog);

  showWindow = (selector, id) => {
    const { height: panelBottomHeight } = document.querySelector(".bottomContainer").getBoundingClientRect();
    const { top: itemTop } = selector.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const tooltipHeight = 324;
    const xAdjust = selector?.offsetWidth || 20;

    const heightSelector = (itemTop + tooltipHeight) - panelBottomHeight;
    const isAdjustable = heightSelector >= windowHeight;

    const eventLog = new App.Models.EventLog();


    Monet.Tooltip.addTooltip({
      selector,
      my: isAdjustable ? "left bottom" : "left center",
      classe: ("notificationWindow qtip-light eventid-" + id),
      adjust: {
        x: xAdjust + 10
      },
      hide: () => {
        const qtipEventDiv = document.querySelector(`.qtip.notificationWindow.eventid-${id}`);
        if(qtipEventDiv) {
          qtipEventDiv.remove();
        }
        eventLog.releaseEventLog();
      },
    });
    this.getEventData(eventLog, id, selector);
  };

  showWindowToRouteDetails = (eventLog) => {
    this.setEventLog(eventLog);
    const entity = Monet.Utils.GetTabName();
    const tabs = Greenmile.EventNotifications.window.CreateTabStructure(this.eventLog, entity);
    const contentPopup = this.getContentPopup();
    this.createEventLogDiv();

    render(contentPopup, this.eventLogDiv);

    this.eventLogDiv.querySelector('#tooltipDetalheEvento').appendChild(tabs);
    $(tabs).tabs({ active: 0 });
    return this.eventLogDiv;
  };

  createEventLogDiv = () => {
    const selector = `EventWindow-${this.eventLog.id}`;
    this.eventLogDiv = document.createElement('div');
    this.eventLogDiv.setAttribute('class', `EventWindow ${selector}`);
    this.eventLogDiv.selector = selector;
  };

  getContentPopup = () => {
    const { id, messageBody, closed } = this.eventLog;
    const msgOpen = Monet.I18n.getResourcesByKey('EventLog.btn.open.chat');
    const msgClose = Monet.I18n.getResourcesByKey('notificationPanel.btnShowCloseEvent');
    const msgNewTask = Monet.I18n.getResourcesByKey('EventLog.AddNewTask');
    const buttonConf = { className: 'btn', type: "button" };
    const closedConf = {
      ...buttonConf,
      onClick: this.closeEvent,
      value: msgClose,
      name: 'closeButton',
    };
    if (closed) {
      closedConf['disabled'] = true;
    }
    const chatConf = {
      ...buttonConf,
      onClick: this.openChat,
      value: msgOpen,
    };
    if (
      !( ((this.eventLog.route &&
      this.eventLog.route.driverAssignments &&
      this.eventLog.route.driverAssignments.length) ||
      (this.eventLog.driver) ) &&
      Monet.Session.Chat.Service.enabled)
    ) {
      chatConf['disabled'] = true;
    }

    if (messageBody) {
      return (
        <div className="popupEvent">
          <div className="mapStreetView" />
          <div className="mapEventContainer" />
          <div className="popupPadding">{messageBody}
            <div>
              <input {...chatConf} />
              <input {...closedConf} />
              <input {...buttonConf} value={msgNewTask} onClick={this.openNewTask} />
            </div>
          </div>
          <div className="eventLogDetail">
            <div className="eventtype_containner" id={`eventtype_containner_${id}`}>
              <div id="tooltipDetalheEvento" />
            </div>
          </div>
        </div>
      );
    }
    return '';
  };

  openChat = () => {
    let driver = null;
    if (this.eventLog?.route && this.eventLog?.route?.driverAssignments?.length) {
      driver = this.eventLog.route.driverAssignments[0].driver;
    } else if (this.eventLog.driver) {
      driver = this.eventLog.driver;
    }

    const { dispatch } = window.globalStore;
    const payload = {
      from: driver.id,
      fromName: driver.name
    };

    dispatch(actionCreators.addNewChatWindow(payload));
  };

  closeEvent = () => {
    if (!this.eventLog.closed) {
      let currentTab = `#${Monet.Utils.GetTabName()}`;
      currentTab = (currentTab === '#TrackEquipmentMapsDisplay')
                   ? '#TrackEquipmentMaps'
                   : currentTab;

      const containerScopeBlock = '.mapToolbarContaineer';
      const { id } = this.eventLog;
      const cancelModal = new Greenmile.Views.EventNotification.CancelEvent();
      cancelModal.setEvent(this.eventLog);
      cancelModal.setEventId(id);
      cancelModal.setSelector(`#${id}`);
      cancelModal.setCallback(null);
      cancelModal.show({
          selector: currentTab,
          scopeBlock: `${currentTab} ${containerScopeBlock}`,
          width: 280,
          height: 250
      });
      Monet.Session.WindowNotification.cancelEventModal = cancelModal;
    }
  };

  openNewTask = () => {
    delete this.eventLog.entity;
    const tabAlreadyExists = document.getElementById('Task');
    Monet.Session.Task.eventLog = this.eventLog;
    if (window.location.href.match(/Task\/new/g)) {
        App.Objects.Task.form_new();
    } else {
        window.location.href = '#/Task/new';
    }
    if (tabAlreadyExists) {
        $("#tabs").tabs("select", 'Task');
    }
  };

  getEventData = (eventLog, id, selector, callback) => {
    eventLog.set({ id: id });
    const openPopupCallback = (response, enableOrDisableCloseButton) => {
      $(selector).qtip('show');
      if (response.status && response.status === 409) {
        this.getEventDataByRestrictions({
          id: id,
          criteria: Greenmile.EventLog.Util.criteria,
          selector: selector,
          callback: (callback) ? callback.execute.bind(this) : null,
          callBackShowPopup: enableOrDisableCloseButton,
          eventLog
        });
      } else {
        this.showPopEventNotification({
          data: response,
          id: id,
          selector: selector,
          callback: callback
        });
      }
    }
    eventLog.getDataAndOpenPopup(openPopupCallback);
  };

  showPopEventNotification = param => {
    if (param.data) {
      this.renderInformation(param.data, param.selector);
    } else {
      Monet.Tooltip.hideTooltip(param.selector);
    }
  };

  renderInformation = ({ attributes: eventLog }, selector) => {
    if (eventLog) {
      this.setEventLog(eventLog);
      const renderTab = function(eventLogNotes) {
        this.eventLog.eventLogNotes = eventLogNotes;

        const entity = Monet.Utils.GetTabName();
        const contentPopup = this.getContentPopup();
        const tabs = Greenmile.EventNotifications.window.CreateTabStructure(this.eventLog, entity);
        this.createEventLogDiv();

        render(contentPopup, this.eventLogDiv);

        this.eventLogDiv.querySelector('#tooltipDetalheEvento').appendChild(tabs);

        Monet.Tooltip.updateContentTooltip(selector, this.eventLogDiv);

        $(tabs).tabs({ active: 0 });

        this.addMapEvent(entity);
      }.bind(this);
      const query = {
        criteriaChain: []
      };
      query.criteriaChain.push({
          "and": [
              { "attr": "eventLog.id", "eq": eventLog.id }
          ]
      });
      const request = new DefaultRequest({
          method: "POST",
          url: 'EventLogNotes/restrictions?criteria={"filters":["user.key","user.name","comment","noteTime"]}',
          data: query,
          success: renderTab,
          error: function (error) {
            renderTab(null, error);
          }
      });
      request.send();
    }
  };

  addMapEvent = entity => {

    const bounds = [];

    if (this.eventLog.latitude && this.eventLog.longitude) {
      bounds.push([this.eventLog.latitude, this.eventLog.longitude]);
    } else if(this.eventLog.stop && this.eventLog.stop.latitude && this.eventLog.stop.longitude) {
      bounds.push([this.eventLog.stop.latitude, this.eventLog.stop.longitude]);
    }

    if (bounds.length) {

        const markerImage = require("static/images/map/markers/marker.png");
        const map = this.showMarkerAndInitializeMap(markerImage, entity);

        this.renderMapToolbar(map, `.EventWindow-${this.eventLog.id} .popupEvent .mapEventContainerShow`);

        if (this.eventLog.stop && this.eventLog.stop.latitude) {
            const stopPosition = [this.eventLog.stop.latitude, this.eventLog.stop.longitude];

            const mIcon = window.L.icon({
                iconUrl: require("static/images/map/markers/location.png"),
                iconAnchor: [0, 10]
            });

            window.L.marker(stopPosition,
              { icon: mIcon }
            ).addTo(map);

            bounds.push(stopPosition);
        }

        map.fitBounds(bounds);
    }

  };

  renderMapToolbar = (map, selector) => {
    const { latitude, longitude, stop } = this.eventLog;
    const helper = new Monet.UI.Help('EventLogDetail', Monet.I18n.getResourcesByKey('Map.Tab.EventLogs'));
    if (latitude && longitude) {
      map.lastEventNotification = { latitude, longitude };
    } else if (stop && stop.latitude && stop.longitude) {
      map.lastEventNotification = { latitude: stop.latitude, longitude: stop.longitude };
    }

    map.eventLogDiv = this.eventLogDiv;
    map.mapStreetView = this.eventLogDiv.querySelector('.mapStreetView');

    const entity = Monet.Utils.GetTabName();
    this.toolbar = new Greenmile.Toolbar.Map(map, `#${entity} ${selector}`, {}, helper);
    this.toolbar.enable([
        this.toolbar.actions.fitToMarkers,
        this.toolbar.actions.zoom,
        this.toolbar.actions.source,
        this.toolbar.actions.points
    ]);
    this.toolbar.render();
  };

  showMarkerAndInitializeMap = (sourceIcon) => {
    const { latitude, longitude, stop } = this.eventLog;
    const mapContainer = this.eventLogDiv.querySelector('.mapEventContainer');
    mapContainer.setAttribute('class', 'mapEventContainer mapEventContainerShow');
    const map = Greenmile.Map.Utility.createDefaultMap(mapContainer);
    const baseLayer = Greenmile.Map.Utility.createBaseLayer();
    map.addLayer(baseLayer);
    const mIcon = window.L.icon({ iconUrl: sourceIcon });
    if (latitude && longitude) {
      const iconPath = require("./../../../static/" + this.eventLog.event.icon);
      const eventIcon = window.L.icon({
        iconUrl: iconPath,
        iconSize: [24,24]
      });
      window.L.marker([latitude, longitude], { icon: eventIcon }).addTo(map);
    } else if (stop && stop.latitude && stop.longitude) {
      window.L.marker([stop.latitude, stop.longitude], { icon: mIcon }).addTo(map);
    }
    return map;
  };

  getMessageEventLogLocked = ({ key, parameters: { currentOwner, currentOpenedWhen } }) => {
    const translatedMessage = Monet.I18n.getResourcesByKey(key);
    if (currentOwner) {
      const currentOwnerKey = currentOwner.match(/key=(.+)/)[1].split(/,|]/)[0];
      const openedWhen = Monet.Format.DateTime.formatToLocale(currentOpenedWhen + '+0000');
      return translatedMessage.replace('{currentOpenedWhen}', openedWhen)
                              .replace('{currentOwner}', currentOwnerKey);
    }
    return translatedMessage;
  };

  getEventDataByRestrictions = params => {
    const eventLog = params.eventLog;
    eventLog.filterWithRestrictions({
      criteria: params.criteria,
      success: data => {
        params.data = data;
        this.showPopEventNotification(params);
        if (params.callBackShowPopup) {
          params.callBackShowPopup();
        }
      },
      error: () => {
        Monet.Tooltip.hideTooltip(Monet.Session.WindowNotification.selector);
      }
    });
  };

};
